export enum StatusReportFormat {
    PDF = 'PDF',
    IMAGE = 'IMAGE',
    EXCEL = 'EXCEL',
}
